import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { API_GET } from '../../helpers/api';
import * as actions from '../actions/stations';
import { GET_STATIONS_REQUESTED, STATION_SEARCH_REQUESTED } from '../types';

function* watchStationSearch() {
  yield takeLatest(STATION_SEARCH_REQUESTED, stationSearch);
}

function* watchGetStations() {
  yield takeEvery(GET_STATIONS_REQUESTED, getStations);
}

function* stationSearch(action) {
  try {
    const res = yield call(apiStationSearch, action.payload);
    yield put(actions.stationSearchSucceeded(res.data.items));
  } catch (err) {
    yield put(actions.stationSearchFailed());
  }
}

function* getStations(action) {
  try {
    const res = yield call(apiGetStations, action.payload);
    yield put(actions.getStationsSucceeded(res.data.items));
  } catch (err) {
    yield put(actions.getStationsFailed());
  }
}

export default function* stationSaga() {
  yield all([fork(watchGetStations), fork(watchStationSearch)]);
}

function apiGetStations(organizationId) {
  return API_GET('station', {
    organizationId: organizationId ? organizationId : null,
    page: 0,
    size: 1000,
  });
}

function apiStationSearch(searchParam) {
  return API_GET('station/search', {
    stationSearchParam: searchParam,
    page: 0,
    size: 1000,
  });
}
